import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import React from 'react';
import { useStaticQuery, Link, withPrefix } from 'gatsby';
import styled from '@xstyled/styled-components';
// eslint-disable-next-line import/no-unresolved
import { useLocation } from '@reach/router';
var SideNavQuery = "1339625561";
var createOrFindGroup = function createOrFindGroup(name, groups) {
  var existingGroup = groups.find(function (group) {
    return group.name === name;
  });
  if (existingGroup) return existingGroup;
  var group = {
    name: name,
    nodes: []
  };
  groups.push(group);
  return group;
};
var DEFAULT_ORDER_VALUE = -9999;
var sortNodes = function sortNodes(a, b) {
  var diff = a.fields.order !== DEFAULT_ORDER_VALUE && b.fields.order !== DEFAULT_ORDER_VALUE ? a.fields.order - b.fields.order : a.fields.order !== DEFAULT_ORDER_VALUE ? -1 : b.fields.order !== DEFAULT_ORDER_VALUE ? 1 : a.fields.title.localeCompare(b.fields.title);
  return diff === 0 ? 0 : diff > 0 ? 1 : -1;
};
var groupNodes = function groupNodes(nodes) {
  return nodes.reduce(function (groups, node) {
    if (!node.fields.title) return groups;
    var group = createOrFindGroup(node.fields.section || 'Docs', groups);
    group.nodes.push(node);
    group.nodes.sort(sortNodes);
    return groups;
  }, []);
};
var Nav = styled.nav.withConfig({
  displayName: "SideNav__Nav",
  componentId: "sc-1fg7unw-0"
})(["padding:4 3 5;"]);
var NavGroup = styled.div.withConfig({
  displayName: "SideNav__NavGroup",
  componentId: "sc-1fg7unw-1"
})(["margin-bottom:4;"]);
var NavGroupTitle = styled.h4.withConfig({
  displayName: "SideNav__NavGroupTitle",
  componentId: "sc-1fg7unw-2"
})(["font-size:14;font-weight:500;color:on-background-light;text-transform:uppercase;margin:0 0 3 0;"]);
var NavGroupMenu = styled.ul.withConfig({
  displayName: "SideNav__NavGroupMenu",
  componentId: "sc-1fg7unw-3"
})(["margin:0;padding:0;border-left:1;border-left-color:layout-border;"]);
var NavGroupMenuItem = styled.li.withConfig({
  displayName: "SideNav__NavGroupMenuItem",
  componentId: "sc-1fg7unw-4"
})(["list-style-type:none;margin:2 0 0 -2px;padding:0;font-size:14;font-weight:500;a{color:on-background-light;display:block;transition:fast;transition-property:color,border-color;padding:2px 0 2px 2;border-left:3;border-color:transparent;text-decoration:none;opacity:0.85;&:hover{color:on-background;opacity:1;}&[aria-current='page']{font-weight:600;border-color:primary;color:on-background;opacity:1;}}"]);
var sortGroupsWithConfig = function sortGroupsWithConfig(section) {
  return function (a, b) {
    var indexA = section.indexOf(a.name);
    var indexB = section.indexOf(b.name);
    var diff = indexA - indexB;
    return diff === 0 ? 0 : diff < 0 ? -1 : 1;
  };
};
export function useSideNavState() {
  var data = useStaticQuery(SideNavQuery);
  return React.useMemo(function () {
    var navGroups = groupNodes(data.allMdx.edges.map(function (edge) {
      return edge.node;
    }));
    navGroups.sort(sortGroupsWithConfig(data.site.siteMetadata.sections));
    return {
      navGroups: navGroups
    };
  }, [data]);
}
export function useSideNavPrevNext(_ref) {
  var navGroups = _ref.navGroups;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var nodes = navGroups.flatMap(function (group) {
    return group.nodes;
  });
  var nodeIndex = nodes.findIndex(function (node) {
    return withPrefix(node.fields.slug) === pathname;
  });
  return {
    prev: nodeIndex > -1 ? nodes[nodeIndex - 1] : null,
    next: nodeIndex > -1 ? nodes[nodeIndex + 1] : null
  };
}
export function SideNav(_ref2) {
  var navGroups = _ref2.navGroups;
  return /*#__PURE__*/React.createElement(Nav, null, navGroups.map(function (navGroup, index) {
    return /*#__PURE__*/React.createElement(NavGroup, {
      key: index
    }, /*#__PURE__*/React.createElement(NavGroupTitle, null, navGroup.name), /*#__PURE__*/React.createElement(NavGroupMenu, null, navGroup.nodes.map(function (page) {
      return /*#__PURE__*/React.createElement(NavGroupMenuItem, {
        key: page.id
      }, /*#__PURE__*/React.createElement(Link, {
        to: page.fields.slug
      }, page.fields.title));
    })));
  }));
}